import { ROUTES } from "../../../constant";
import { isEmbedMode } from "../../../utils/embedMode";
import { isAppEmbedFlow } from "../../../utils/embedPortalBridge";

interface BottomNavVisibilityParams {
  pathname: string;
  isMobile: boolean;
  isBottomDrawerOpen: boolean;
  isBookingSearchForm: boolean;
}

export function shouldShowBottomNav({
  pathname,
  isMobile,
  isBottomDrawerOpen,
  isBookingSearchForm,
}: BottomNavVisibilityParams): boolean {
  if (!isMobile) return false;
  // Native mobile app (WebView, ticket login — `isAppEmbedFlow`) gets the nav so
  // users can reach Shop / Trips; its pages live under /portal/*. Partner
  // website iframe embeds (portal flow) and any other embed stay nav-less.
  const nativeApp = isAppEmbedFlow();
  if (isEmbedMode() && !nativeApp) return false;
  if (pathname.startsWith("/portal")) {
    if (!nativeApp) return false;
    // Shop mirrors /booking: nav only on the search form, not inside the flow.
    if (pathname.startsWith(ROUTES.PortalShop)) return isBookingSearchForm && !isBottomDrawerOpen;
  }
  if (isBottomDrawerOpen) return false;
  if (pathname.startsWith(ROUTES.onBoarding)) return false;
  if (pathname.startsWith(ROUTES.BookingLoader)) return false;
  if (pathname.startsWith("/payment")) return false;
  if (pathname.startsWith(ROUTES.BookingInProgress)) return isBookingSearchForm;
  return true;
}
